/**
 * Footer Component
 * Handles footer interactions and Shopify theme editor support
 */

(function() {
  'use strict'; 

  // Configuration
  const CONFIG = {
    selectors: {
      footer: '[data-section-type="footer"]',
    },
    breakpoints: {
      mobile: 768
    }
  };

  /**
   * Footer Class
   */
  class Footer {
    constructor(element) {
      this.element = element;
      this.isMobile = window.innerWidth <= CONFIG.breakpoints.mobile;

      this.init();
    }

    init() {
      // Mobile menus are always expanded - no accordion functionality needed
      // Just bind window resize for potential future enhancements
      this.bindEvents();
    }

    /**
     * Bind event listeners
     */
    bindEvents() {
      // Handle window resize
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.handleResize();
        }, 250);
      });
    }

    /**
     * Handle window resize
     */
    handleResize() {
      this.isMobile = window.innerWidth <= CONFIG.breakpoints.mobile;
      // Future: Add any resize-specific logic here
    }
  }

  /**
   * Initialize all footer sections
   */
  function initFooter() {
    const footerElements = document.querySelectorAll(CONFIG.selectors.footer);

    footerElements.forEach(element => {
      new Footer(element);
    });
  }

  /**
   * Initialize when DOM is ready
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooter);
  } else {
    initFooter();
  }

  /**
   * Shopify Section Editor support
   */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector(CONFIG.selectors.footer)) {
        initFooter();
      }
    });

    document.addEventListener('shopify:section:reorder', function(event) {
      if (event.target.querySelector(CONFIG.selectors.footer)) {
        initFooter();
      }
    });
  }

})();
